import script from "./LilaTransferTicket.vue?vue&type=script&setup=true&lang=js"
export * from "./LilaTransferTicket.vue?vue&type=script&setup=true&lang=js"

import "./LilaTransferTicket.vue?vue&type=style&index=0&id=6961b007&lang=css"

const __exports__ = script;

export default __exports__